import subjects from "../../data/subjects";
import { sendMessage } from "../../wsFunctions/socket";

function GetHelpForm(props) {
    function sendForm() {
        if (props.subject !== "none") {
            let userIDLocalStorage = localStorage.getItem("userID");

            sendMessage({type: "help-request-create", data: {subject: props.subject, userID: userIDLocalStorage, subject: props.subject, location: [props.category, props.number]}});
        } else {
            alert("Då må velge fag for å sende en forespørsel.")
        };
    };

    

    // Liste over alle fag brukt for mapping
    const subjectArr = subjects;

    return (
        <div id="ask-form-student-page" style={{display: ((props.status===undefined) ? "flex" : "none")}}>
            < div id = "list-clearification-student-page" >↓</div >
                <select onChange={(e) => { props.setSubject(e.target.value) }} name="subject" id="subject-selector" value={props.subject}>
                    <option value="none" disabled hidden>Velg fag</option>
                    {/* Mappe ut alle valgene */ }
                    {subjectArr.map((group, i) => (
                        <optgroup label={group.groupName} key={i} >
                            {group.subjects.map((subjectFromArr, j) => (
                                <option key={j} value={subjectFromArr.value}>{subjectFromArr.text}</option>
                            ))}
                        </optgroup>
                    ))}
                </select>
            {/* Status oversikt som vises etter en forespørsel er sendt */ }
            <button onClick={sendForm} id="request-help-student-page">Tilkall leksehjelp</button>
        </div>
    );
};

export default GetHelpForm;